const VARIANTS = {
  light: "bg-surface",
  plain: "bg-white",
  dark: "bg-navy",
};

export default function Card({ variant = "light", className = "", children }) {
  return (
    <div
      className={`relative flex flex-col rounded-[25px] p-[26px] ${VARIANTS[variant]} ${className}`}
    >
      {children}
    </div>
  );
}
